import React, { useEffect, useRef, useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHTituloGet } from "services/services-mia/RNHTituloGet";
import { RNHTituloUpd } from "services/services-mia/RNHTituloUpd";

export default function UpdateModal({ updateList, user, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [inRequest, setInRequest] = useState(false);

    const getTituloData = async () => {
        setIsLoading(true);
        const result = await RNHTituloGet(credentials, { id: user.id })
        formikRef.current.setValues({
            id: result[0].rnhTituloId,
            nombre: result[0].rnhTituloNombre,
            cod: result[0].rnhTituloCod,
        });
        setData(result[0]);
        setIsLoading(false);
    }
    const handleSubmit = async (values) => {
        const response = await RNHTituloUpd(credentials, {
            id: data.rnhTituloId,
            name: values.nombre,
            cod: values.cod,
            version: data.rnhTituloVersion,
        })
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Titulo modificado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };
    useEffect(() => {
        getTituloData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un código")
                })
            }
            onSubmit={(values) => {
                handleSubmit(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="nombre"
                        placeholder=""
                        labelText="Nombre de Titulo"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="cod"
                        placeholder=""
                        labelText="Código de Titulo"
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Modificar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
